"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityContactInfo = exports.EntityContactInfoDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var link_1 = require("../elements/link");
var use_icons_1 = require("../../hooks/use-icons");
var use_lang_1 = require("../../hooks/use-lang");
exports.EntityContactInfoDefaultProps = {
  iconSize: 48,
  spacing: 3
};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var LinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-bottom: ", ";\n    font-size: ", ";\n    font-weight: 500;\n\n    &:last-child {\n      margin-bottom: ", ";\n    }\n  "], ["\n    margin-bottom: ", ";\n    font-size: ", ";\n    font-weight: 500;\n\n    &:last-child {\n      margin-bottom: ", ";\n    }\n  "])), theme_1.theme.UNIT(3), theme_1.theme.FONT_SIZE(15), theme_1.theme.UNIT(1))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Link: (0, styled_components_1.default)(link_1.Link)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles)
};
var EntityContactInfo = function (props) {
  var className = props.className,
    entity = props.entity,
    iconSize = props.iconSize,
    spacing = props.spacing;
  var pinterest = entity.pinterest,
    phone = entity.phone,
    email = entity.email,
    twitter = entity.twitter,
    facebook = entity.facebook,
    instagram = entity.instagram,
    youtube = entity.youtube,
    linkedin = entity.linkedin,
    threads = entity.threads;
  var t = (0, use_lang_1.useLang)();
  var url = entity.url || entity.website || entity.websiteUrl;
  var blog = entity.blogUrl || entity.blog;
  var crunchbase = entity.crunchbaseUrl || entity.crunchbase;
  var angelList = entity.angelList || entity.angelListUrl;
  var Icons = (0, use_icons_1.useIcons)();
  return react_1.default.createElement(My.Container, {
    className: className
  }, email && react_1.default.createElement(My.Link, {
    icon: react_1.default.createElement(Icons.Social.Email, null),
    to: "mailto:".concat(email),
    iconSize: iconSize,
    spacing: spacing
  }, email), phone && react_1.default.createElement(My.Link, {
    icon: react_1.default.createElement(Icons.Social.Phone, null),
    to: "tel:".concat(phone),
    iconSize: iconSize,
    spacing: spacing
  }, phone), url && react_1.default.createElement(My.Link, {
    iconSize: iconSize,
    icon: react_1.default.createElement(Icons.Social.WebFilledCircle, null),
    to: url,
    spacing: spacing
  }, t('Visit Website')), blog && react_1.default.createElement(My.Link, {
    iconSize: iconSize,
    icon: react_1.default.createElement(Icons.BookmarkCircle, null),
    to: url,
    spacing: spacing
  }, t('Blog')), linkedin && react_1.default.createElement(My.Link, {
    iconSize: iconSize,
    icon: react_1.default.createElement(Icons.Social.LinkedinFilledCircle, null),
    to: entity.linkedin,
    spacing: spacing
  }, t('Linkedin')), threads && react_1.default.createElement(My.Link, {
    iconSize: iconSize,
    icon: react_1.default.createElement(Icons.Social.ThreadsFilledCircle, null),
    to: threads,
    spacing: spacing
  }, t('Threads')), twitter && react_1.default.createElement(My.Link, {
    iconSize: iconSize,
    icon: react_1.default.createElement(Icons.Social.XFilledCircle, null),
    to: twitter,
    spacing: spacing
  }, t('X')), facebook && react_1.default.createElement(My.Link, {
    iconSize: iconSize,
    icon: react_1.default.createElement(Icons.Social.FacebookFilledCircle, null),
    to: facebook
  }, t('Facebook')), youtube && react_1.default.createElement(My.Link, {
    iconSize: iconSize,
    icon: react_1.default.createElement(Icons.Social.YoutubeFilledCircle, null),
    to: youtube,
    spacing: spacing
  }, t('Youtube')), pinterest && react_1.default.createElement(My.Link, {
    iconSize: iconSize,
    icon: react_1.default.createElement(Icons.Entities.Link, null),
    to: pinterest,
    spacing: spacing
  }, t('Pinterest')), instagram && react_1.default.createElement(My.Link, {
    icon: react_1.default.createElement(Icons.Social.InstagramFilledCircle, null),
    to: instagram,
    iconSize: iconSize,
    spacing: spacing
  }, t('Instagram')), crunchbase && react_1.default.createElement(My.Link, {
    icon: react_1.default.createElement(Icons.Entities.Link, null),
    to: crunchbase,
    iconSize: iconSize,
    spacing: spacing
  }, t('Crunchbase')), angelList && react_1.default.createElement(My.Link, {
    icon: react_1.default.createElement(Icons.Entities.Link, null),
    to: angelList,
    iconSize: iconSize,
    spacing: spacing
  }, t('AngelList')));
};
exports.EntityContactInfo = EntityContactInfo;
exports.EntityContactInfo.defaultProps = exports.EntityContactInfoDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;